import { Application } from '../../../Models/Application';

export const ApplicationsReducerName = 'applications';

export interface IApplicationsState {
  applications: Application[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
